
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAutonomousFill as ObiAutonomousFillElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-autonomous-fill.js';
 
 
 

 
 export const ObiAutonomousFill = createComponent({
   react: React,
   tagName: 'obi-autonomous-fill',
   elementClass: ObiAutonomousFillElement,
   events: {
     
   }
  });
 
 